import { Controller } from "@hotwired/stimulus"

function debounce(fn, wait = 300) {
  let timerId
  return (...args) => {
    clearTimeout(timerId)
    timerId = setTimeout(() => fn.apply(null, args), wait)
  }
}

export default class extends Controller {
  static targets = ["input", "results"]
  static values = { 
    minCharsMessage: String,
    noResultsMessage: String,
    errorMessage: String
  }

  connect() {
    this.query = debounce(this.query.bind(this), 300)
  }

  query() {
    const term = this.inputTarget.value.trim()

    if (term.length < 3) {
      this.resultsTarget.innerHTML = `
        <li class="list-group-item text-muted">
          ${this.minCharsMessageValue}
        </li>
      `
      return
    }

    fetch(`/assignments/autocomplete?q=${encodeURIComponent(term)}`)
      .then(r => (r.ok ? r.json() : []))
      .then(hits => {
        if (hits.length === 0) {
          this.resultsTarget.innerHTML = `
            <li class="list-group-item text-muted">
              ${this.noResultsMessageValue.replace('%{term}', term)}
            </li>
          `
        } else {
          this.resultsTarget.innerHTML = hits
            .map(hit => `
              <li class="list-group-item">
                <a href="/assignments/${hit.assignment_id}?open_return_modal=true&selected_product_id=${hit.product_id}" target="_blank" class="fw-semibold">
                  ${hit.full_number}
                </a><br>
                <small class="text-muted">
                  ${hit.product_name} (${hit.product_reference} / ${hit.product_id})
                </small>
              </li>
            `)
            .join("")
        }
      })
      .catch(() => {
        this.resultsTarget.innerHTML = `
          <li class="list-group-item text-danger">
            ${this.errorMessageValue}
          </li>
        `
      })
  }
}